import type { EdgeActionCapabilities, EdgeDescriptor } from '@bliks-io/ui';
import type { EdgeAction } from './types';

export function canPerformEdgeAction(action: EdgeAction, edge: EdgeDescriptor): boolean {
  const sKind = edge.source.kind;
  const tKind = edge.target.kind;
  if (sKind === 'end') return false;
  if (action === 'disconnect' || action === 'insertBetween') return true;
  if (action === 'forkFromSource') return sKind !== 'assignment';
  if (action === 'mergeIntoTarget') {
    return sKind !== 'start' && tKind !== 'end' && tKind !== 'gateway';
  }
  if (action === 'markUnclear') {
    // Only edges touching an assignment get mark-as-unclear; start sources
    // are excluded because start has no `successorStatus` to flip.
    return sKind !== 'start' && (sKind === 'assignment' || tKind === 'assignment');
  }
  return false;
}

export function getEdgeActionCapabilities(edge: EdgeDescriptor): EdgeActionCapabilities {
  return {
    insertBetween: canPerformEdgeAction('insertBetween', edge),
    forkFromSource: canPerformEdgeAction('forkFromSource', edge),
    mergeIntoTarget: canPerformEdgeAction('mergeIntoTarget', edge),
    markUnclear: canPerformEdgeAction('markUnclear', edge),
    disconnect: canPerformEdgeAction('disconnect', edge)
  };
}
